module.exports = __webpack_public_path__ + "img/w3_close_dark.19fe8123.png";